/* eslint-disable react/prop-types */
import './AdminSettings.scss';
import { useTranslation } from 'react-i18next';
import { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import TabNav from '../../../Components/TabNav/TabNav';
import GeneralSettings from './GeneralSettings';
import ClientSettings from './ClientSettings/ClientSettings';
import UserSettings from './UserSettings/UserSettings';
import AuthLinkSettings from './AuthLinkSettings/AuthLinkSettings';
import XpektorSlider from '../../../Components/XpektorSlider/XpektorSlider';
import UserService from '../../../Services/UserService';
import CustomerService from '../../../Services/CustomerService';
import UserGroupService from '../../../Services/UserGroupService';

const gT = (t, key) => t(`page-admin-settings${key}`);
const gsT = (t, key) => t(`shared${key}`);

export default function AdminSettings() {
  const { t } = useTranslation('app');
  const [activeTab, setActiveTab] = useState('');
  const [tabIndex, setTabIndex] = useState(0);
  const [currentUser, setCurrentUser] = useState({});
  const [users, setUsers] = useState([]);
  const [userGroups, setUserGroups] = useState([]);
  const [clients, setClients] = useState([]);
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    const getData = async () => {
      const user = await UserService.getCurrentUser();
      if (user.role < 1) {
        history.push('/app/dashboard');
      }
      setCurrentUser(user);

      await CustomerService.getUsers(user.customerId)
        .then((response) => {
          setUsers(
            response.data.sort((a, b) => {
              const stringA = a.name.toUpperCase();
              const stringB = b.name.toUpperCase();
              return stringA < stringB ? -1 : stringA > stringB ? 1 : 0;
            })
          );
        })
        .catch(() => {});

      await UserGroupService.getUserGroups()
        .then((response) => {
          setUserGroups(response.data);
        })
        .catch(() => {});

      await CustomerService.getCustomerClients(user.customerId)
        .then((response) => {
          setClients(response.data);
        })
        .catch(() => {});
    };

    document.title = gT(t, '.document-title');
    getData();
  }, [history, t]);

  const fetchUserGroups = async () => {
    await UserGroupService.getUserGroups()
      .then((response) => {
        setUserGroups(response.data);
      })
      .catch(() => {});
  };

  const fetchUsers = async () => {
    await CustomerService.getUsers(currentUser.customerId)
      .then((response) => {
        setUsers(
          response.data.sort((a, b) => {
            const stringA = a.name.toUpperCase();
            const stringB = b.name.toUpperCase();
            return stringA < stringB ? -1 : stringA > stringB ? 1 : 0;
          })
        );
      })
      .catch(() => {});
  };

  useEffect(() => {
    const isLocation = (path) => {
      return window.location.href.indexOf(path) !== -1;
    };

    if (isLocation('settings/clients')) {
      setActiveTab('clients');
      setTabIndex(1);
    } else if (isLocation('settings/users')) {
      setActiveTab('users');
      setTabIndex(2);
    } else if (isLocation('settings/links')) {
      setActiveTab('links');
      setTabIndex(3);
    } else {
      setActiveTab('general');
      setTabIndex(0);
    }
  }, [location]);

  function renderSettings() {
    return (
      <XpektorSlider
        activeSlideIndex={
          activeTab === 'general'
            ? 0
            : activeTab === 'clients'
            ? 1
            : activeTab === 'users'
            ? 2
            : activeTab === 'links'
            ? 3
            : ''
        }
      >
        <XpektorSlider.Slide hidden={activeTab !== 'general'}>
          <GeneralSettings t={t} />
        </XpektorSlider.Slide>
        <XpektorSlider.Slide hidden={activeTab !== 'clients'}>
          <ClientSettings
            clients={clients}
            users={users}
            userGroups={userGroups}
            t={t}
          />
        </XpektorSlider.Slide>
        <XpektorSlider.Slide hidden={activeTab !== 'users'}>
          <UserSettings
            users={users}
            userGroups={userGroups}
            clients={clients}
            currentUser={currentUser}
            onGroupEdit={fetchUserGroups}
            onUserEdit={fetchUsers}
            t={t}
          />
        </XpektorSlider.Slide>
        <XpektorSlider.Slide hidden={activeTab !== 'links'}>
          <AuthLinkSettings t={t} />
        </XpektorSlider.Slide>
      </XpektorSlider>
    );
  }

  return (
    <div className="admin-settings-wrapper">
      <div className="admin-settings-head">
        <p className="admin-settings-title">{gT(t, '.title')}</p>
      </div>
      <div className="admin-nav-container">
        <TabNav activeIndex={tabIndex}>
          <TabNav.Tab
            title={gsT(t, '.labels.general')}
            active={tabIndex === 0}
            onClick={() => {
              history.replace({ pathname: '/app/settings/general' });
              setTabIndex(0);
            }}
          />
          <TabNav.Tab
            title={gsT(t, '.labels.clients')}
            active={tabIndex === 1}
            onClick={() => {
              history.replace({ pathname: '/app/settings/clients' });
              setTabIndex(1);
            }}
          />
          <TabNav.Tab
            title={gsT(t, '.labels.users')}
            active={tabIndex === 2}
            onClick={() => {
              history.replace({ pathname: '/app/settings/users' });
              setTabIndex(2);
            }}
          />
          <TabNav.Tab
            title={gsT(t, '.labels.links')}
            active={tabIndex === 3}
            onClick={() => {
              history.replace({ pathname: '/app/settings/links' });
              setTabIndex(3);
            }}
          />
        </TabNav>
      </div>
      {renderSettings()}
    </div>
  );
}
